import React, { useEffect, useState } from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import Marquee from '../components/Marquee';
import JourneySteps from '../components/JourneySteps';
import HerHis from '../components/HerHis';
import Arsenal from '../components/Arsenal';
import EveryStage from '../components/EveryStage';
import AlfaDifference from '../components/AlfaDifference';
import Pricing from '../components/Pricing';
import Faq from '../components/Faq';
import Disclosure from '../components/Disclosure';
import Footer from '../components/Footer';
import { getMarquee } from '../lib/api';

export default function WeightLoss() {
  const [marqueeItems, setMarqueeItems] = useState([]);
  useEffect(() => {
    let cancelled = false;
    getMarquee('weightLoss')
      .then((m) => { if (!cancelled) setMarqueeItems(m.items || []); })
      .catch((e) => console.error('WeightLoss marquee load failed', e));
    return () => { cancelled = true; };
  }, []);

  return (
    <>
      <div className="telegra-bg" aria-hidden="true" />
      <Header />
      <main>
        <Hero />
        <Marquee items={marqueeItems} />
        <JourneySteps />
        <AlfaDifference />
        <EveryStage />
        <Arsenal />
        <HerHis />
        <Pricing />
        <Faq />
        <Disclosure />
      </main>
      <Footer />
    </>
  );
}
